import { useState, useEffect } from "react";
import { useMutation, useQueryClient } from "react-query";
import * as apiClient from "../api-client";
import { useAppContext } from "../contexts/AppContext";
import { FaSignOutAlt } from "react-icons/fa";

interface SignOutButtonProps {
  onClick?: () => void;
}

const SignOutButton: React.FC<SignOutButtonProps> = ({ onClick }) => {
  const [isVisible, setIsVisible] = useState(false);
  const queryClient = useQueryClient();
  const { showToast } = useAppContext();

  const mutation = useMutation(apiClient.signOut, {
    onSuccess: async () => {
      await queryClient.invalidateQueries("validateToken");
      showToast({ message: "Signed Out!", type: "SUCCESS" });
    },
    onError: (error: Error) => {
      showToast({ message: error.message, type: "ERROR" });
    },
  });

  const handleClick = () => {
    mutation.mutate();
    if (onClick) onClick();
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 0); // 10 seconds delay

    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
  <button
    onClick={handleClick}
    className="mr-10 text-sm text-black px-3 font-medium rounded h-8 flex items-center space-x-2 hover:text-halo-pink"
    aria-label="Sign-Out"
  >
    <span>Sign Out</span>
    <FaSignOutAlt className="text-md hover:text-halo-pink" />
  </button>
  );
};

export default SignOutButton;
